import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import "./Dashboard.css";
import dayjs from "dayjs";
import MapContainer from "../../components/Map/MapContainer"; // Updated import
import AreaChart from "../../components/Chart/AreaChart";
import { images } from "../../config/images";
import Slider from "react-slick";
import BarChart from "../../components/Chart/BarChart";
import PieChart from "../../components/Chart/PieChart";
import { useNavigate } from "react-router";
import ProductsChart from "../../components/Chart/ProductsChart";
import ScanByChart from "../../components/Chart/ScanByChart";
import {
  getDailyScanPatternsCounts,
  getDashboardInsights,
  getDeviceTypesCount,
  getProductCount,
  getScanbyUserRoleCount,
  getTopCounterfeitLocations,
  getTopCrossSellingLocations,
  getUserRoleList,
} from "../Pipes/services";

const Dashboard = () => {
  const [startDateReFormat, setStartDateReFormat] = useState(null);
  const [endDateReFormat, setEndDateReFormat] = useState(null);
  const dateFormat = "YYYY-MM-DD";
  const [dailyScanData, setDailyScanData] = useState([]);
  const [getPipesData, setGetPipesData] = useState([]);
  const [pipeStats, setPipeStats] = useState([]);
  const [productId, setProductId] = useState();
  const [showTime, setShowTime] = useState(false);
  const [productData, setProductData] = useState([]);
  const [selectRoleId, setRoleId] = useState(null);
  const [scanByUserData, setScanByUserData] = useState({});
  const [roleList, setRoleList] = useState([]);
  const [deviceData, setDeviceData] = useState({});
  const [crossSellingData, setCrossSellingData] = useState([]);
  const [counerfeiltData, setCounterFeiltData] = useState([]);
  const [insightsData, setInsightsData] = useState([]);

  console.log("sdfsdfsd", deviceData);

  const startDateData = dayjs(startDateReFormat).format("YYYY-MM-DD HH:mm:ss");
  const endDateData = dayjs(endDateReFormat).format("YYYY-MM-DD HH:mm:ss");

  const startDateData1 = dayjs(startDateReFormat).format("YYYY-MM-DD");
  const endDateData1 = dayjs(endDateReFormat).format("YYYY-MM-DD");

  const navigate = useNavigate();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  useEffect(() => {
    if (getPipesData && Object.keys(getPipesData).length > 0) {
      const stats = [
        {
          value: getPipesData.passed_count?.genuine_count || 0,
          label: getPipesData.total_count?.total_count || 0,
          percentage: Number(
            getPipesData.passed_count?.percentage || 0
          ).toFixed(2),
          trend: getPipesData.passed_count?.increase ? "up" : "down",
          background: images.greenPipeBackground,
          color: "green",
        },

        {
          value: getPipesData.cross_selling_count?.cross_selling_count || 0,
          label: getPipesData.total_count?.total_count || 0,
          percentage: Number(
            getPipesData.cross_selling_count?.percentage || 0
          ).toFixed(2),
          trend: getPipesData.cross_selling_count?.increase ? "up" : "down",
          background: images.yellowPipeBackground,
          color: "yellow",
        },
        {
          value: getPipesData.failed_count?.counterfeit_count || 0,
          label: getPipesData.total_count?.total_count || 0,
          percentage: Number(
            getPipesData.failed_count?.percentage || 0
          ).toFixed(2),
          trend: getPipesData.failed_count?.increase ? "up" : "down",
          background: images.redPipeBackground,
          color: "red",
        },
      ];

      setPipeStats(stats);
    } else {
      setPipeStats([]);
    }
  }, [getPipesData]);

  useEffect(() => {
    if (productId) {
      handleProduct();
      handleDeviceData();
      handleTopCrossSellingData();
      handleTopCounterFeiltData();
      handleDailyScanData();
      handleInsightsData();
    }
  }, [productId, startDateData, endDateData, startDateData1, endDateData1]);

  useEffect(() => {
    if (selectRoleId && productId) {
      handleScanByUserData();
    }
  }, [
    productId,
    selectRoleId,
    startDateData,
    endDateData,
    startDateData1,
    endDateData1,
  ]);

  useEffect(() => {
    handleRoleData();
  }, []);
  const buildParams = () => {
    const params = {
      product_id: productId,
      start_date: showTime ? startDateData : `${startDateData1} 00:00:00`,
      end_date: showTime ? endDateData : `${endDateData1} 23:59:59`,
    };
    return params;
  };

  const fetchData = async (apiCall, setDataCallback) => {
    const params = buildParams();
    try {
      const resp = await apiCall(params);
      if (resp.status === 200 || resp.status === 201) {
        setDataCallback(resp.data.payload);
      }
    } catch (error) {
      setDataCallback({});
    }
  };

  const handleProduct = async () => {
    await fetchData(getProductCount, setProductData);
  };

  const handleDeviceData = async () => {
    await fetchData(getDeviceTypesCount, setDeviceData);
  };

  const handleTopCrossSellingData = async () => {
    await fetchData(getTopCrossSellingLocations, setCrossSellingData);
  };

  const handleTopCounterFeiltData = async () => {
    await fetchData(getTopCounterfeitLocations, setCounterFeiltData);
  };

  const handleDailyScanData = async () => {
    await fetchData(getDailyScanPatternsCounts, setDailyScanData);
  };

  const handleScanByUserData = async () => {
    const params = {
      role_id: selectRoleId,
      product_id: productId,
    };
    if (showTime) {
      params["start_date"] = startDateData;
      params["end_date"] = endDateData;
    } else {
      params["start_date"] = `${startDateData1} 00:00:00`;
      params["end_date"] = `${endDateData1} 23:59:59`;
    }
    try {
      const resp = await getScanbyUserRoleCount(params);
      if (resp.status == 200 || resp.status == 201) {
        setScanByUserData(resp.data.payload);
      }
    } catch (error) {
      setScanByUserData();
    }
  };

  const handleRoleData = async () => {
    try {
      const resp = await getUserRoleList();
      if (resp.status == 200 || resp.status == 201) {
        const roles = resp.data.payload;
        setRoleList(roles);
        const astralTeamRole = roles.find((role) =>
          role.name?.toLowerCase().includes("astral")
        );
        setRoleId(astralTeamRole ? astralTeamRole.id : roles[0]?.id);
      }
    } catch (error) {
      setRoleList([]);
    }
  };

  const handleInsightsData = async () => {
    const params = {
      product_id: productId,
    };
    if (showTime) {
      params["start_date"] = startDateData;
      params["end_date"] = endDateData;
    } else {
      params["start_date"] = `${startDateData1} 00:00:00`;
      params["end_date"] = `${endDateData1} 23:59:59`;
    }
    try {
      const resp = await getDashboardInsights(params);
      if (resp.status == 200 || resp.status == 201) {
        setInsightsData(resp.data.payload);
      }
    } catch (error) {
      setInsightsData([]);
    }
  };

  return (
    <Box className="dashboard-container">
      <Grid container spacing={2}>
        {/* Left Section - Stats */}
        <Grid item size={{ xs: 12, md: 3 }}>
          <Box className="left-section">
            <Box className="pipes-container">
              <Box className="pipe-box">
                <div className="insights-header pipe-header">
                  <div className="header-text">Pipes</div>
                  <img
                    src={images.redirectIcon}
                    alt="redirect"
                    className="redirect-icon"
                    onClick={() => navigate("/pipes-details")}
                  />
                </div>
                <Box className="pipes-content">
                  {pipeStats.length > 0 ? (
                    pipeStats.map((stat, index) => (
                      <div className="pipe-stat" key={index}>
                      <div
                        className="shield"
                        style={{ backgroundImage: `url(${stat.background})` }}
                      >
                        <div className="tooltip">
                          {stat.color === "green" ? "Genuine" : stat.color === "yellow" ? "Cross Selling" : "Counterfeit"}
                        </div>
                        <div className="shield-inner">
                          <div className="stat-value">{stat.value}</div>
                          <div className="stat-label">{stat.label}</div>
                          <div className={`stat-percentage ${stat.color}`}>
                            {stat.trend === "up" ? "▲" : "▼"}{" "}
                            {stat.percentage}%
                          </div>
                        </div>
                      </div>
                    </div>
                    ))
                  ) : (
                    <div style={{ height: "150px" }}>
                      {" "}
                      <img
                        src={images.noDataFoundImg}
                        className="no-data-img"
                        alt="No Data Found"
                      />
                    </div>
                  )}
                </Box>
              </Box>
            </Box>
            <Box className="products-container">
              <Box className="products-box">
                <div className="insights-header products-header">
                  <div className="header-text">Products</div>
                  <img
                    src={images.redirectIcon}
                    alt="redirect"
                    className="redirect-icon"
                    onClick={() => navigate("/product-details")}
                  />
                </div>
                <div className="products-content">
                  {productData.length > 0 ? (
                    <ProductsChart productData={productData} />
                  ) : (
                    <div>
                      {" "}
                      <div className="no-data-container-chart">
                        <img
                          src={images.noDataFoundImg}
                          className="no-data-img"
                          alt="No Data Found"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </Box>
            </Box>
            <Box className="scan-by-countainer">
              <Box className="scan-by-box">
                <div className="insights-header scan-by-header">
                  <div className="header-text">Scan By</div>
                </div>
                <div className="scan-by-content">
                  {scanByUserData && Object.keys(scanByUserData).length > 0 ? (
                    <ScanByChart
                      selectRoleId={selectRoleId}
                      setRoleId={setRoleId}
                      roleList={roleList}
                      scanByUserData={scanByUserData}
                    />
                  ) : (
                    <div>
                      {" "}
                      <div className="no-data-container-chart">
                        <img
                          src={images.noDataFoundImg}
                          className="no-data-img"
                          alt="No Data Found"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Middle Section - Map */}
        <Grid item size={{ xs: 12, md: 6 }}>
          <Box className="map-section">
            <MapContainer
              startDateReFormat={startDateReFormat}
              setStartDateReFormat={setStartDateReFormat}
              endDateReFormat={endDateReFormat}
              setEndDateReFormat={setEndDateReFormat}
              setGetPipesData={setGetPipesData}
              setProductId={setProductId}
              showTime={showTime}
              setShowTime={setShowTime}
              roleList={roleList}
              setRoleList={setRoleList}
            />
          </Box>
          <Box className="daily-scan">
            <div className="daily-scan-title">
              <b className="daily-title">Daily Scan Pattern</b>
            </div>
            <div className="daily-scan-content">
              {dailyScanData.length > 0 ? (
                <AreaChart chartData={dailyScanData} />
              ) : (
                <div className="no-data-container-chart">
                  <img
                    src={images.noDataFoundImg}
                    className="no-data-img"
                    alt="No Data Found"
                  />
                </div>
              )}
            </div>
          </Box>
        </Grid>

        {/* Right Section - Charts */}
        <Grid item size={{ xs: 12, md: 3 }}>
          <Box className="right-section">
            <Box className="insights-container">
              <Box className="insight-box">
                <div className="insights-header">
                  <div className="header-text">
                    Insights! (<span>powered by</span>{" "}
                    <span className="hai">hai</span>
                    <sup> ®</sup>)
                  </div>
                </div>
                <div className="insights-content">
                  <Slider
                    {...settings}
                    dots={true}
                    customPaging={(i) => <div className="custom-dot"></div>}
                    appendDots={(dots) => (
                      <ul className="slick-dots">{dots.slice(0, 4)}</ul>
                    )}
                  >
                    {insightsData.map((insight, index) => (
                      <>
                        <div className="insight-slide">
                          <p>{insight}</p>
                        </div>
                      </>
                    ))}
                  </Slider>
                </div>
              </Box>
            </Box>
            <Box className="counterfeit-location-container">
              <Box className="counterfeit-location-box">
                <div className="insights-header counterfeit-location-header">
                  <div className="header-text">Top 5 Counterfeit Locations</div>
                </div>
                <div className="counterfeit-location-content">
                  {counerfeiltData.length > 0 ? (
                    <BarChart
                      type={"counterFeit"}
                      crossSellingData={counerfeiltData}
                    />
                  ) : (
                    <div className="no-data-container-chart">
                      <img
                        src={images.noDataFoundImg}
                        className="no-data-img"
                        alt="No Data Found"
                      />
                    </div>
                  )}
                </div>
              </Box>
            </Box>
            <Box className="cross-selling-container">
              <Box className="cross-selling-box">
                <div className="insights-header cross-selling-header">
                  <div className="header-text">
                    Top 5 Cross Selling Locations
                  </div>
                </div>
                <div className="cross-selling-content">
                  {crossSellingData.length > 0 ? (
                    <BarChart
                      type={"crossSelling"}
                      crossSellingData={crossSellingData}
                    />
                  ) : (
                    <div className="no-data-container-chart">
                      <img
                        src={images.noDataFoundImg}
                        className="no-data-img"
                        alt="No Data Found"
                      />
                    </div>
                  )}
                </div>
              </Box>
            </Box>
            <Box className="devices-container">
              <Box className="devices-box">
                <div className="insights-header devices-header">
                  <div className="header-text">Devices</div>
                </div>
                <div className="devices-content">
                  {deviceData && Object.keys(deviceData).length > 0 ? (
                    <PieChart deviceData={deviceData} />
                  ) : (
                    <div className="no-data-container-chart">
                      <img
                        src={images.noDataFoundImg}
                        className="no-data-img"
                        alt="No Data Found"
                      />
                    </div>
                  )}
                </div>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
